import { SbbDialogElement } from "@sbb-esta/lyne-elements/dialog.js";
import { SbbDialog, SbbDialogActions, SbbDialogContent, SbbDialogTitle } from "@sbb-esta/lyne-react/dialog";
import React, { PropsWithChildren, ReactNode, useEffect, useRef } from "react";

export interface LyneDialogProps extends PropsWithChildren {
  backdrop?: "translucent" | "opaque";
  isOpen: boolean;
  title: ReactNode | undefined;
  content: ReactNode | undefined;
  actions: ReactNode | undefined;
}

export const LyneDialog: React.FC<LyneDialogProps> = ({
  isOpen,
  backdrop = "translucent",
  title,
  content,
  actions,
}) => {
  const ref = useRef<SbbDialogElement | null>(null);

  useEffect(() => {
    const rc = ref.current;
    if (!rc) return;

    const currentIsOpen = rc.isOpen;
    if (currentIsOpen === isOpen) return;

    if (isOpen) {
      rc.open();
    } else {
      rc.close();
    }
  }, [isOpen]);

  return (
    <SbbDialog backdrop={backdrop} ref={ref}>
      <SbbDialogTitle>{title}</SbbDialogTitle>
      <SbbDialogContent>{content}</SbbDialogContent>
      <SbbDialogActions>{actions}</SbbDialogActions>
    </SbbDialog>
  );
};
